<template>
  <a-steps :current="datalist.length-1">
    <a-step :title="moment(new Date(item.createAt)).format('YYYY-MM-DD HH:mm:ss')" :description="$t(item.status)"  :key="item.id" v-for="item in datalist"></a-step>
  </a-steps>
</template>

<script>
import moment from 'moment';
import { _queryOrderRecords } from '@/api/websiteOrderApi.js';

async function getOrderRecordlist() {
  if (this.goodsOrderId) {
    const result = await _queryOrderRecords(this.goodsOrderId);
    if (result) {
      this.datalist = result.reverse();
    }
  }
}

export default {
  name: 'OrderStatusChangeWebsite',
  props: {
    goodsOrderId: String,
  },
  data() {
    return {
      moment: moment,
      datalist: []
    };
  },
  methods: {
    getOrderRecordlist,
  },
  created() {
    this.getOrderRecordlist();
  }
};
</script>

<style scoped lang="scss">

</style>
